module.exports = __webpack_public_path__ + "54e876f63227d763925ab19f34eef1fe.jpg";